var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditi7334K9R = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6313 2C20.547 2 22.1 3.55275 22.1 5.46865C22.1 6.31773 21.7886 7.13467 21.229 7.76705L21.0839 7.92122L14.1172 14.8879C13.7445 15.2606 13.2886 15.539 12.7885 15.7008L12.5716 15.763L6.92571 17.1743L8.33707 11.528C8.46515 11.0164 8.71289 10.5432 9.0582 10.1475L9.21209 9.98278L16.1788 3.01609C16.7097 2.48515 17.3964 2.14272 18.1638 2.03407L18.3963 2.00853L18.6313 2ZM18.634 4L18.5151 4.00461C18.2171 4.02827 17.9342 4.14237 17.7037 4.33028L17.593 4.43031L16.7688 5.25455L18.8455 7.33124L19.6697 6.507C19.9453 6.23141 20.1 5.85799 20.1 5.46865C20.1 4.70512 19.5176 4.07787 18.775 4.00672L18.634 4ZM17.4312 8.74545L15.3545 6.66876L11.133 10.8903L12.6906 11.4094L13.2097 12.967L17.4312 8.74545ZM9.674 14.425L10.1157 12.6592L11.109 12.99L11.4405 13.984L9.674 14.425Z",
    fill: "#0054A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.964 5.99947L11.965 3.99947L5.5 4L5.32373 4.00509C3.80725 4.09296 2.59296 5.30725 2.50509 6.82373L2.5 7V19L2.50509 19.1763C2.59296 20.6928 3.80725 21.907 5.32373 21.9949L5.5 22H17.5L17.6763 21.9949C19.1928 21.907 20.407 20.6928 20.4949 19.1763L20.5 19V11.5345L18.5 13.5345V19L18.4933 19.1166C18.4399 19.5757 18.0757 19.94 17.6166 19.9933L17.5 20H5.5L5.38338 19.9933C4.9243 19.94 4.56005 19.5757 4.50673 19.1166L4.5 19V7L4.50673 6.88338C4.56005 6.4243 4.9243 6.06005 5.38338 6.00673L5.5 6L9.964 5.99947Z",
    fill: "#0054A4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditi7334K9R);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/editi733-4k9r.14027fb67060946100d2f6a829306afa.svg";